module.exports = __webpack_public_path__ + "static/final.dd08aa1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/routing/final.png
// module id = 199
// module chunks = 91164660736209 111767854568034